import { defineMessages } from 'react-intl';

export default defineMessages({
  about: {
    id: 'navigation.navLink.about',
    description: 'Navigation about link',
    defaultMessage: 'Näin luet selvitystä',
  },
  login: {
    id: 'navigation.navLink.login',
    description: 'Login',
    defaultMessage: 'Kirjaudu sisään',
  },
  logout: {
    id: 'navigation.navLink.logout',
    description: 'Logout',
    defaultMessage: 'Kirjaudu ulos',
  },
  searchCompanies: {
    id: 'navigation.navLink.searchCompanies',
    description: 'Search other companies',
    defaultMessage: 'Hae muita yrityksiä',
  },
  tos: {
    id: 'navigation.navLink.tos',
    description: 'Terms of service',
    defaultMessage: 'Käyttöehdot',
  },
  controlPanel: {
    id: 'navigation.navLink.controlPanel',
    description: 'Control panel',
    defaultMessage: 'Hallintapaneeli',
  },
  companyInstructions: {
    id: 'navigation.navLink.companyInstructions',
    description: 'Company instructions',
    defaultMessage: 'Ohjeet yrityksille',
  },
});
